/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { $, td, uid } from '../theme';
import Ic from '../Icon';
export default function PayModal({ t, onClose, onOk, addPayment }) {
  const [amt, setAmt]       = useState(t?.monthly_rent||t?.rent||'');
  const [mth, setMth]       = useState('ACH');
  const [note, setNote]     = useState('');
  const [payDate, setPayDate] = useState(td());
  const [loading, setLoading] = useState(false);
  const submit = async () => {
    if(!amt) return;
    setLoading(true);
    const refNo = `PAY-${uid().toUpperCase().slice(0,6)}`;
    const [yr, mo] = (payDate || td()).split('-');
    const mthName = new Date(parseInt(yr), parseInt(mo)-1, 1).toLocaleString('en-US', { month:'long', year:'numeric' });
    const payload = {
      tenant_id:    t?.id,
      amount:       parseFloat(amt),
      method:       mth,
      payment_date: payDate || td(),
      mth_name:     mthName,
      reference_no: refNo,
      status:       'paid',
      notes:        note || null,
    };
    let saved = payload;
    if (addPayment) {
      const { data, error } = await addPayment(payload);
      if (!error && data) saved = data;
    }
    onOk && onOk(saved);
    setLoading(false);
    onClose();
  };
  return (
    <div className="mov" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal">
        <div className="mhd"><h2>Record Payment</h2><button className="btn btn-gh" style={{padding:'5px 9px'}} onClick={onClose}><Ic n="x" s={15}/></button></div>
        <div className="mbdy">
          <div style={{textAlign:'center',marginBottom:20}}>
            <div style={{fontFamily:"'Playfair Display',serif",fontSize:18,fontWeight:700,color:'#fff'}}>{t?.full_name||t?.name}</div>
            <div style={{fontSize:12,color:'#8b949e'}}>Unit {t?.unit||t?.u||'—'}</div>
          </div>
          <div className="fg">
            <div className="fi fi-f"><label>Amount ($)</label><input type="number" value={amt} onChange={e=>setAmt(e.target.value)} placeholder="0.00" autoFocus/></div>
            <div className="fi"><label>Method</label><select value={mth} onChange={e=>setMth(e.target.value)}><option>ACH</option><option>Card</option><option>Check</option><option>Cash</option><option>Venmo</option><option>Zelle</option></select></div>
            <div className="fi"><label>Payment Date</label><input type="date" value={payDate} onChange={e=>setPayDate(e.target.value)}/></div>
            <div className="fi fi-f"><label>Notes</label><textarea value={note} onChange={e=>setNote(e.target.value)} placeholder="Optional note..."/></div>
          </div>
          <div style={{display:'flex',gap:10,justifyContent:'flex-end',marginTop:8}}>
            <button className="btn btn-gh" onClick={onClose}>Cancel</button>
            <button className="btn btn-g" onClick={submit} disabled={loading||!amt}><Ic n="check" s={14}/>{loading?'Saving...':'Record Payment'}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
